import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Product', path: '/product' },
    { name: 'Solutions', path: '/solutions' },
    { name: 'Marketplace', path: '/marketplace' },
    { name: 'Pricing', path: '/pricing' },
    { name: 'Docs', path: '/docs' }
  ];

  const isDark = location.pathname === '/';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/80 backdrop-blur-xl shadow-sm py-4' : 'bg-transparent py-6'}`}>
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center space-x-2">
          <div className="w-8 h-8 bg-brand-indigo rounded-lg flex items-center justify-center">
            <span className="text-brand-mint font-bold text-lg">hd</span>
          </div>
          <span className={`text-xl font-display font-bold tracking-tight ${scrolled || !isDark ? 'text-brand-indigo' : 'text-white'}`}>
            HDAI Software
          </span>
        </Link>

        <div className="hidden md:flex items-center space-x-10">
          {navLinks.map((link) => (
            <Link 
              key={link.path}
              to={link.path}
              className={`text-sm font-semibold transition-colors ${scrolled || !isDark ? 'text-brand-indigo/70 hover:text-brand-indigo' : 'text-white/70 hover:text-white'}`}
            >
              {link.name}
            </Link>
          ))}
        </div>

        <div className="flex items-center space-x-4">
          <Link 
            to="/login" 
            className={`text-sm font-semibold px-4 py-2 rounded-xl transition-all ${scrolled || !isDark ? 'text-brand-indigo hover:bg-brand-indigo/5' : 'text-white hover:bg-white/10'}`}
          >
            Log in
          </Link>
          <Link 
            to="/signup" 
            className="bg-brand-indigo text-white text-sm font-bold px-6 py-2.5 rounded-xl hover:bg-brand-slate transition-all shadow-md active:scale-95"
          >
            Start Building
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;